<ul class="breadcrumb breadcrumb-page">
  <li><a href="#">{{'app.Home' | translate}}</a></li>
  <li class="active">{{'pageHeader.representation' | translate}}</li>
</ul>

<div class="page-header">
  <div class="row">
    <h1 class="col-xs-12 col-sm-4 text-center text-left-sm"><img [src]="logo" class="img-icon" />&nbsp;&nbsp;{{'pageHeader.representation' | translate}}</h1>
  </div>
</div>

<div class="panel panel-default widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'representation.representationSearch' | translate}}</span>
  </div>

  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-6">
        </div>
        <div class="col-sm-3 margin-top-10">
        </div>
        <div class="col-sm-3 margin-top-10 left-6 cursor-pointer" (click)="gotoNew()">
          <span class="margin-right-7 create-new-span">{{'representation.createNewRepresentation' | translate}}</span>
          <i class="fa fa-plus-circle"></i>
        </div>
      </div>
    </div>
  </div>
</div>

<crm-save-representations *ngIf="addNew" (closeEvent)="closeAdding($event)" [itemId]="selectedRepresentationsId"></crm-save-representations>
<crm-representation-items *ngIf="representationItemsMode" (closeEvent)="closeAdding($event)" [representationId]="selectedRepresentationsId"></crm-representation-items>

<div class="panel panel-success widget-support-tickets">
  <div class="panel-heading">
    <span class="panel-title">{{'representation.representationSearchResult' | translate}}</span>
  </div>
  <div class="panel-body padding-sm-hr">
    <div class="form-group no-margin-hr panel-padding-h no-padding-t no-border-t">
      <div class="row">
        <div class="col-sm-12">

          <p-table #dt [value]="representations" [responsive]="true" sortMode="multiple" [paginator]="true" [rows]="pageSize">
            <ng-template pTemplate="header">
              <tr>
                <!--<th width="5%">#</th>-->
                <th class="table-edit">{{'Id' | translate}}</th>
                <th class="table-edit">{{'representation.order' | translate}}</th>
                <th class="table-edit">{{'app.name' | translate}}</th>
                <th class="table-edit">{{'Item Name' | translate}}</th>
                <th class="table-edit">{{'Items' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.edit' | translate}} {{'app.name' | translate}}</th>
                <th width="10%" style="text-align:center" class="table-edit">{{'app.delete' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-item>
              <tr *ngIf="representations.length>0 ">
                <td>
                  <strong>{{item.id}}</strong>
                </td>
                <td>{{ item.order }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.itemBrandName? item.itemBrandName:item.itemName }}</td>
                <td>
                  <a class="" href="javascript:;" (click)="getItems(item.id)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td>
                  <a class="" href="javascript:;" (click)="gotoEdit(item.id)"><i class="fa fa-edit fa-lg font-size-20"></i></a>
                </td>
                <td><a href="javascript:;" (click)="confirmDeleteItem(item)"><i class="fa fa-trash-o  fa-lg font-size-20"></i></a></td>
              </tr>
              <tr *ngIf="representations.length==0">
                <td colspan="3">{{'app.NoDataFound' | translate}}</td>
              </tr>

            </ng-template>

          </p-table>

        </div>

      </div>
    </div>
  </div>
</div>


<div class="modal fade" bsModal #deleteModal="bs-modal" [config]="{backdrop: 'static'}" tabindex="-1">
  <div class="modal-dialog modal-lg">
    <div class="panel padding-2">
      <div>
        <h1 class="delete-title">{{'app.deleteMsgConfirmation' | translate}}</h1>
      </div>
      <div class="row panel-body padding-sm-hr padding-top-0 padding-bottom-0">

        <div class="panel-footer margin-left-20 margin-top-20">
          <button type="button" (click)="hideDeleteModal()" class="btn btn-cancel">{{'app.cancel' | translate}}</button>
          <button type="button" class="btn btn-save" (click)="delete()">{{'app.delete' | translate}}</button>
        </div>
      </div>
    </div>
  </div>
</div>

